import { useApplication } from '@/hooks/useApplication';
import { SubroutineId } from '@/types/subroutine';
import { Variable, VariableRef, VariableScope } from '@/types/variable';
import { isNumber } from '@/util/typeGuards';
import { List, ListItemButton, ListItemText } from '@mui/material';
import { FC, useEffect, useState } from 'react';

type PromptListsListProps = {
  value?: VariableRef | number;
  subroutineId: SubroutineId;
  onClick: (promptList: VariableRef) => void;
  onDoubleClick: (promptList: VariableRef) => void;
};

const PromptListsList: FC<PromptListsListProps> = (props) => {
  const { application } = useApplication();

  const [availablePromptLists, setAvailablePromptLists] = useState<VariableRef[]>();

  useEffect(() => {
    const promptListsList: VariableRef[] = [];
    Object.entries(application.variables).map(([variableScope, variables]) => {
      if (variables.constructor === Array) {
        variables.map((variable) => {
          if (variable.type !== 'promptlist' || variable.name.startsWith('_debug')) return;

          promptListsList.push({ name: variable.name, scope: variableScope as VariableScope });
        });
      } else {
        Object.entries(variables).map(([subroutineId, variables]) => {
          if (subroutineId !== props.subroutineId?.toString()) return;

          variables.map((variable: Variable) => {
            if (variable.type !== 'promptlist' || variable.name.startsWith('_debug')) return;

            promptListsList.push({ name: variable.name, scope: variableScope as VariableScope });
          });
        });
      }
    });

    setAvailablePromptLists(promptListsList);
  }, []);

  return (
    <List sx={{ width: '100%', flex: '1 1 auto', minHeight: 0, overflowY: 'auto' }}>
      {availablePromptLists?.map((variable, index) => {
        if (isNumber(props.value)) return;

        return (
          <ListItemButton
            key={`prompt.${variable.name}.${index}`}
            selected={variable.name === props.value?.name}
            onClick={() => props.onClick({ name: variable.name, scope: variable.scope })}
            onDoubleClick={() => props.onDoubleClick({ name: variable.name, scope: variable.scope })}
            sx={{ gap: 1 }}
          >
            <ListItemText primary={variable.name} />
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default PromptListsList;
